import * as React from "react";
function XxlIcon() {
    return React.createElement("path", { d: "M24 31.9383L12.6924 20.6307L14.3231 19L24 28.7077L33.6769 19.0307L35.3077 20.6615L24 31.9383Z", fill: "currentColor" });
}
export default XxlIcon;
//# sourceMappingURL=Xxl.js.map